export default __webpack_public_path__ + "static/media/32.fd9c3a67.png";